export default __webpack_public_path__ + "static/media/typedJS.05fc7dcb.png";